export default __webpack_public_path__ + "static/media/DownloadConfigFileforUpload-MSSQL.bdb01752.png";